export default {
    name: 'CheckmarkCircleFill',
    dimensions: { width: 22, height: 22 },
    content: `
    <path d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
    <path d="M15.5 8L9.5 14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.5 11L9.5 14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  `
};
